/**
 * KB-META
 * Purpose: Main
 * Role: ui.module
 * EntryPoints: 
 * Inputs: 
 * Outputs: 
 * Validation: 
 * Dependencies: 
 * Contracts: 
 * Auth&Privacy: auth:none; hipaa:none; pii:none
 * Observability: 
 * Router: shard=partner-portal-cura; H2=src/main; tags=ui
 * Owner: ; LastReviewed: 2025-08-25
 */
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
import { AppComponent } from './app.component';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';

// Provide a runtime override for legacy API Gateway JS SDK clients (assets/js/apigClient.js)
// so they hit the correct dev/prod base URL without hardcoding.
try {
  const invokeUrl =
    typeof (environment as any)?.altV1Url === 'string'
      ? (environment as any).altV1Url.replace(/\/+$/g, '')
      : '';
  if (invokeUrl) {
    (window as any).__GENUS_APIG_INVOKE_URL__ = invokeUrl;
  }
} catch {}

// Suppress console logs in production
if (environment.production) {
  enableProdMode();
  window.console.log = () => {
    // Don't log anything.
  };
  window.console.warn = () => {
    // Don't log anything.
  }
  // Keep console.error for critical errors
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
